import React from "react";
import "../Footer/footer.css";

const Footer = () => {
  return (
    <>
       <div class="card-footer text-center">
        <small>&copy; copyright Karishma's Portfolio 2023.</small>
      </div>
    </>
  );
};

export default Footer;
